// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__IMfTl","name":"style_name__3RkLD","button":"style_button__10t0D","time":"style_time__2R4AW","percentage":"style_percentage__vUwV_","bar":"style_bar__2wfbl"};